// app.config.ts
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import {
  MessageService,
  TransfloThemeComponents,
  TransfloThemePrimitives,
  TransfloThemeSemantic,
} from '@transflo/transflo-design-system';

import { provideAnimations } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { authInterceptor } from './shared/interceptors/auth/auth.interceptor';
import { errorInterceptor } from './shared/interceptors/error.Interceptor';
import { timeoutInterceptor } from './shared/interceptors/timeoutInterceptor';

const transfloPreset = definePreset(Aura, {
  primitive: { ...TransfloThemePrimitives },
  semantic: { ...TransfloThemeSemantic },
  components: { ...TransfloThemeComponents },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    provideAnimations(),

    // PrimeNG + MessageService
    providePrimeNG({
      theme: {
        preset: transfloPreset,
        options: { darkModeSelector: false },
      },
    }),
    MessageService, // ← THIS FIXES THE ERROR

    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor, timeoutInterceptor, errorInterceptor])
    ),
  ],
};
